"use client";

import { useMemo } from "react";
import type { EconomicEvent } from "@/vybe-trader-client/economic-calendar/types";
import { filterEventsBySeriesKey } from "@/vybe-trader-client/economic-calendar/series-key";

export function useEconomicSeriesDetail(
  seriesKey: string | null,
  allEvents: readonly EconomicEvent[]
): {
  occurrences: EconomicEvent[];
  /** Most recent occurrence by ISO timestamp (preferred header anchor) */
  canonicalEvent: EconomicEvent | undefined;
} {
  return useMemo(() => {
    if (!seriesKey) {
      return { occurrences: [], canonicalEvent: undefined };
    }
    const occurrences = filterEventsBySeriesKey(allEvents, seriesKey);
    let canonicalEvent: EconomicEvent | undefined;
    for (let i = occurrences.length - 1; i >= 0; i--) {
      const candidate = occurrences[i];
      const t = new Date(candidate.dateTimeISO).getTime();
      if (Number.isFinite(t)) {
        canonicalEvent = candidate;
        break;
      }
    }
    return {
      occurrences,
      canonicalEvent: canonicalEvent ?? occurrences[occurrences.length - 1],
    };
  }, [seriesKey, allEvents]);
}
